import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";
import UnitScopeTabs from "../../components/UnitScopeTabs";

export default function VendedoresMaster() {
  const [unidades, setUnidades] = useState([]);
  const [scope, setScope] = useState("global");
  const [lista, setLista] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ nome: "", unidade_id: "" });

  useEffect(() => {
    api.get("/unidades").then((r) => {
      setUnidades(r.data);
      setForm((f) => ({ ...f, unidade_id: r.data[0]?.id || "" }));
    });
  }, []);

  const load = () => {
    const params = scope === "global" ? {} : { unidade_id: scope };
    api.get("/vendedores", { params }).then((r) => setLista(r.data));
  };
  useEffect(() => {
    load();
  }, [scope]); // eslint-disable-line

  const unitName = (uid) => unidades.find((u) => u.id === uid)?.nome || "—";

  const salvar = async () => {
    if (!form.nome || !form.unidade_id) {
      toast.error("Preencha nome e unidade");
      return;
    }
    await api.post("/vendedores", form);
    toast.success("Vendedor criado");
    setModal(null);
    setForm({ nome: "", unidade_id: unidades[0]?.id });
    load();
  };

  const excluir = async (v) => {
    if (!window.confirm(`Desativar o vendedor ${v.nome}?`)) return;
    await api.delete(`/vendedores/${v.id}`);
    toast.success("Vendedor desativado");
    load();
  };

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">
            Equipe
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">
            Vendedores
          </h2>
        </div>
        <button
          data-testid="vendedor-novo-btn"
          onClick={() => setModal(true)}
          className="bg-neutral-950 text-white h-11 px-4 font-display font-bold uppercase text-xs tracking-widest flex items-center gap-2 cta-brutal"
        >
          <Plus className="w-4 h-4" /> Novo
        </button>
      </div>

      <UnitScopeTabs unidades={unidades} value={scope} onChange={setScope} />

      <div className="bg-white border-2 border-neutral-900 overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-neutral-300 bg-neutral-50">
              <th className="text-left p-3 font-mono text-[10px] uppercase tracking-widest">Nome</th>
              <th className="text-left p-3 font-mono text-[10px] uppercase tracking-widest">Unidade</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {lista.map((v) => (
              <tr key={v.id} className="border-b border-neutral-100 hover:bg-neutral-50">
                <td className="p-3 font-display font-bold">{v.nome}</td>
                <td className="p-3 text-sm">{unitName(v.unidade_id)}</td>
                <td className="p-3 text-right">
                  <button
                    data-testid={`vendedor-excluir-${v.id}`}
                    onClick={() => excluir(v)}
                    className="p-2 border border-neutral-900 hover:bg-red-600 hover:text-white hover:border-red-600"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
            {lista.length === 0 && (
              <tr>
                <td colSpan={3} className="p-8 text-center text-sm text-neutral-500">
                  Nenhum vendedor
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
          <div className="bg-white border-4 border-neutral-900 w-full max-w-md">
            <div className="flex items-center justify-between p-4 border-b-2 border-neutral-900">
              <h3 className="font-display font-bold uppercase">Novo Vendedor</h3>
              <button onClick={() => setModal(null)}>
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 space-y-3">
              <label className="block">
                <span className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                  Nome
                </span>
                <input
                  data-testid="vendedor-form-nome"
                  value={form.nome}
                  onChange={(e) => setForm({ ...form, nome: e.target.value })}
                  className="mt-1 w-full h-11 px-3 border-2 border-neutral-900 font-mono"
                />
              </label>
              <label className="block">
                <span className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                  Unidade
                </span>
                <select
                  data-testid="vendedor-form-unidade"
                  value={form.unidade_id}
                  onChange={(e) => setForm({ ...form, unidade_id: e.target.value })}
                  className="mt-1 w-full h-11 px-3 border-2 border-neutral-900 font-mono bg-white"
                >
                  {unidades.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.nome}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <div className="p-4 border-t-2 border-neutral-900 flex gap-2 justify-end">
              <button
                onClick={() => setModal(null)}
                className="h-10 px-4 border-2 border-neutral-900 bg-white font-display font-bold uppercase text-xs tracking-widest"
              >
                Cancelar
              </button>
              <button
                data-testid="vendedor-form-salvar"
                onClick={salvar}
                className="bg-neutral-950 text-white h-10 px-5 font-display font-bold uppercase text-xs tracking-widest"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
